import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowDown, Truck, Shield, Award } from 'lucide-react';
import trucks52Logo from '@/assets/trucks52-logo-optimized.png';
export const HeroSection = () => {
  const scrollToVehicles = () => {
    requestAnimationFrame(() => {
      const vehiclesSection = document.querySelector('[data-vehicles]');
      if (vehiclesSection) {
        vehiclesSection.scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
  };
  return <section className="hero-section relative">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }}></div>
      </div>
      
      <div className="hero-content relative z-10">
        <div className="hero-grid">
          <div className="text-center md:text-left">
            <div className="mb-6">
              <span className="inline-block px-4 py-2 bg-blue-600/20 rounded-full text-blue-100 text-sm font-medium mb-4">
                Spécialiste depuis 15 ans
              </span>
              <h1 className="hero-title">
                Trucks 52
                <span className="block text-blue-200 text-2xl md:text-3xl font-normal mt-2">
                  Votre partenaire poids lourds
                </span>
              </h1>
              <p className="hero-text">
                Découvrez notre sélection rigoureuse de véhicules industriels d'occasion. 
                Tous nos véhicules sont contrôlés, garantis avec financement et reprise possibles.
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <Button onClick={scrollToVehicles} size="lg" className="bg-white text-blue-900 hover:bg-blue-50 font-semibold px-8 py-3">
                Voir nos véhicules
                <ArrowDown className="ml-2 h-5 w-5" />
              </Button>
              <Button variant="outline" size="lg" className="border-white hover:bg-white font-semibold px-8 py-3 text-blue-900">
                Nous contacter
              </Button>
            </div>

            {/* Trust indicators */}
            <div className="flex flex-wrap gap-6 text-blue-200">
              <div className="flex items-center">
                <Truck className="h-5 w-5 mr-2" />
                <span className="text-sm">500+ véhicules vendus</span>
              </div>
              <div className="flex items-center">
                <Shield className="h-5 w-5 mr-2" />
                <span className="text-sm">Garantie incluse</span>
              </div>
              <div className="flex items-center">
                <Award className="h-5 w-5 mr-2" />
                <span className="text-sm">Expert certifié</span>
              </div>
            </div>
          </div>

          <div className="relative">
            <Card className="bg-white/10 backdrop-blur-sm border-white/20">
              <CardContent className="p-8">
                <div className="text-center">
                  <div className="w-24 h-24 mx-auto mb-6 bg-white/20 rounded-full flex items-center justify-center">
                    <img 
                      src={trucks52Logo} 
                      alt="Trucks 52 Logo" 
                      className="h-16 w-16 object-contain"
                      width="64"
                      height="64"
                      loading="eager"
                    />
                  </div>
                  <h2 className="text-2xl font-bold mb-4">Laurent DESNOUVEAUX</h2>
                  <p className="text-blue-100 mb-6">
                    Votre expert en véhicules industriels depuis plus de 15 ans. 
                    Conseils personnalisés et accompagnement complet.
                  </p>
                  <div className="space-y-3 text-left">
                    <div className="flex items-center text-blue-100">
                      <span className="text-xl mr-3">📞</span>
                      <strong className="text-white">06 08 24 85 29</strong>
                    </div>
                    <div className="flex items-center text-blue-100">
                      <span className="text-xl mr-3">📧</span>
                      <span>trucks.52@orange.fr</span>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
};